var _g, _circle, _path, _path2, _circle2, _circle3, _circle4, _circle5, _g2, _circle6, _path3, _path4, _circle7, _circle8, _circle9, _circle10, _g3, _circle11, _path5, _path6, _circle12, _circle13, _circle14, _circle15, _g4, _circle16, _path7, _path8, _circle17, _circle18, _circle19, _circle20, _g5, _circle21, _path9, _path10, _circle22, _circle23, _circle24, _circle25, _g6, _circle26, _path11, _path12, _circle27, _circle28, _circle29, _circle30, _g7, _circle31, _path13, _path14, _circle32, _circle33, _circle34, _circle35, _g8, _circle36, _path15, _path16, _circle37, _circle38, _circle39, _circle40, _g9, _circle41, _path17, _path18, _circle42, _circle43, _circle44, _circle45, _g10, _circle46, _path19, _path20, _circle47, _circle48, _circle49, _circle50, _g11, _circle51, _path21, _path22, _circle52, _circle53, _circle54, _circle55, _g12, _circle56, _path23, _path24, _circle57, _circle58, _circle59, _circle60, _g13, _circle61, _path25, _path26, _circle62, _circle63, _circle64, _circle65, _g14, _circle66, _path27, _path28, _circle67, _circle68, _circle69, _circle70, _g15, _circle71, _path29, _path30, _circle72, _circle73, _circle74, _circle75, _g16, _circle76, _path31, _path32, _circle77, _circle78, _circle79, _circle80, _g17, _circle81, _path33, _path34, _circle82, _circle83, _circle84, _circle85, _g18, _circle86, _path35, _path36, _circle87, _circle88, _circle89, _circle90, _g19, _circle91, _path37, _path38, _circle92, _circle93, _circle94, _circle95, _g20, _circle96, _path39, _path40, _circle97, _circle98, _circle99, _circle100, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgChipsColIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 38,
    viewBox: "0 0 44 38",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_73_5274)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 16,
    r: 9,
    fill: "white"
  }))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 16,
    r: 5.34375,
    fill: "white",
    stroke: "#57B661",
    strokeWidth: 0.5625
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.3061 12.8153L19.4393 10.9331C19.1308 10.4809 18.7821 10.0584 18.3984 9.6705L18.3296 9.60171C17.9416 9.21789 17.5189 8.8691 17.0666 8.56049L15.1844 10.6937C16.0534 11.2163 16.7834 11.9463 17.3061 12.8153ZM17.306 19.1847C16.7833 20.0537 16.0533 20.7837 15.1843 21.3063L17.0665 23.4395C17.5223 23.1286 17.948 22.7768 18.3383 22.3895L18.3896 22.3382C18.7768 21.948 19.1284 21.5225 19.4392 21.067L17.306 19.1847ZM8.81535 21.306C7.9464 20.7834 7.21636 20.0533 6.69375 19.1843L4.56061 21.0665C5.19609 21.9978 6.00188 22.8037 6.93316 23.4392L8.81535 21.306ZM6.69366 12.8157C7.21626 11.9467 7.94628 11.2166 8.81522 10.6939L6.93307 8.56082C6.0018 9.19636 5.19602 10.0022 4.56055 10.9335L6.69366 12.8157Z",
    fill: "#57B661"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.375 16C15.375 17.864 13.864 19.375 12 19.375C10.136 19.375 8.625 17.864 8.625 16C8.625 14.136 10.136 12.625 12 12.625C13.864 12.625 15.375 14.136 15.375 16Z",
    fill: "#57B661"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 8.6875,
    r: 0.5625,
    fill: "#57B661"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 23.3125,
    r: 0.5625,
    fill: "#57B661"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 19.3125,
    cy: 16,
    r: 0.5625,
    fill: "#57B661"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 4.6875,
    cy: 16,
    r: 0.5625,
    fill: "#57B661"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_d_73_5274)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 15,
    r: 9,
    fill: "white"
  }))), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 15,
    r: 5.34375,
    fill: "white",
    stroke: "#57B661",
    strokeWidth: 0.5625
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.3061 11.8153L19.4393 9.93306C19.1308 9.48092 18.7821 9.05835 18.3984 8.6705L18.3296 8.60171C17.9416 8.21789 17.5189 7.8691 17.0666 7.56049L15.1844 9.69368C16.0534 10.2163 16.7834 10.9463 17.3061 11.8153ZM17.306 18.1847C16.7833 19.0537 16.0533 19.7837 15.1843 20.3063L17.0665 22.4395C17.5223 22.1286 17.948 21.7768 18.3383 21.3895L18.3896 21.3382C18.7768 20.948 19.1284 20.5225 19.4392 20.067L17.306 18.1847ZM8.81535 20.306C7.9464 19.7834 7.21636 19.0533 6.69375 18.1843L4.56061 20.0665C5.19609 20.9978 6.00188 21.8037 6.93316 22.4392L8.81535 20.306ZM6.69366 11.8157C7.21626 10.9467 7.94628 10.2166 8.81522 9.69392L6.93307 7.56082C6.0018 8.19636 5.19602 9.0022 4.56055 9.93352L6.69366 11.8157Z",
    fill: "#57B661"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M15.375 15C15.375 16.864 13.864 18.375 12 18.375C10.136 18.375 8.625 16.864 8.625 15C8.625 13.136 10.136 11.625 12 11.625C13.864 11.625 15.375 13.136 15.375 15Z",
    fill: "#57B661"
  })), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 7.6875,
    r: 0.5625,
    fill: "#57B661"
  })), _circle8 || (_circle8 = /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 22.3125,
    r: 0.5625,
    fill: "#57B661"
  })), _circle9 || (_circle9 = /*#__PURE__*/React.createElement("circle", {
    cx: 19.3125,
    cy: 15,
    r: 0.5625,
    fill: "#57B661"
  })), _circle10 || (_circle10 = /*#__PURE__*/React.createElement("circle", {
    cx: 4.6875,
    cy: 15,
    r: 0.5625,
    fill: "#57B661"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_d_73_5274)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 14,
    r: 9,
    fill: "white"
  }))), _circle11 || (_circle11 = /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 14,
    r: 5.34375,
    fill: "white",
    stroke: "#57B661",
    strokeWidth: 0.5625
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.3061 10.8153L19.4393 8.93306C19.1308 8.48092 18.7821 8.05835 18.3984 7.6705L18.3296 7.60171C17.9416 7.21789 17.5189 6.8691 17.0666 6.56049L15.1844 8.69368C16.0534 9.2163 16.7834 9.94634 17.3061 10.8153ZM17.306 17.1847C16.7833 18.0537 16.0533 18.7837 15.1843 19.3063L17.0665 21.4395C17.5223 21.1286 17.948 20.7768 18.3383 20.3895L18.3896 20.3382C18.7768 19.948 19.1284 19.5225 19.4392 19.067L17.306 17.1847ZM8.81535 19.306C7.9464 18.7834 7.21636 18.0533 6.69375 17.1843L4.56061 19.0665C5.19609 19.9978 6.00188 20.8037 6.93316 21.4392L8.81535 19.306ZM6.69366 10.8157C7.21626 9.94669 7.94628 9.2166 8.81522 8.69392L6.93307 6.56082C6.0018 7.19636 5.19602 8.0022 4.56055 8.93352L6.69366 10.8157Z",
    fill: "#57B661"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M15.375 14C15.375 15.864 13.864 17.375 12 17.375C10.136 17.375 8.625 15.864 8.625 14C8.625 12.136 10.136 10.625 12 10.625C13.864 10.625 15.375 12.136 15.375 14Z",
    fill: "#57B661"
  })), _circle12 || (_circle12 = /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 6.6875,
    r: 0.5625,
    fill: "#57B661"
  })), _circle13 || (_circle13 = /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 21.3125,
    r: 0.5625,
    fill: "#57B661"
  })), _circle14 || (_circle14 = /*#__PURE__*/React.createElement("circle", {
    cx: 19.3125,
    cy: 14,
    r: 0.5625,
    fill: "#57B661"
  })), _circle15 || (_circle15 = /*#__PURE__*/React.createElement("circle", {
    cx: 4.6875,
    cy: 14,
    r: 0.5625,
    fill: "#57B661"
  })), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter3_d_73_5274)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 13,
    r: 9,
    fill: "white"
  }))), _circle16 || (_circle16 = /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 13,
    r: 5.34375,
    fill: "white",
    stroke: "#57B661",
    strokeWidth: 0.5625
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.3061 9.8153L19.4393 7.93306C19.1308 7.48092 18.7821 7.05835 18.3984 6.6705L18.3296 6.60171C17.9416 6.21789 17.5189 5.8691 17.0666 5.56049L15.1844 7.69368C16.0534 8.2163 16.7834 8.94634 17.3061 9.8153ZM17.306 16.1847C16.7833 17.0537 16.0533 17.7837 15.1843 18.3063L17.0665 20.4395C17.5223 20.1286 17.948 19.7768 18.3383 19.3895L18.3896 19.3382C18.7768 18.948 19.1284 18.5225 19.4392 18.067L17.306 16.1847ZM8.81535 18.306C7.9464 17.7834 7.21636 17.0533 6.69375 16.1843L4.56061 18.0665C5.19609 18.9978 6.00188 19.8037 6.93316 20.4392L8.81535 18.306ZM6.69366 9.81568C7.21626 8.94669 7.94628 8.2166 8.81522 7.69392L6.93307 5.56082C6.0018 6.19636 5.19602 7.0022 4.56055 7.93352L6.69366 9.81568Z",
    fill: "#57B661"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M15.375 13C15.375 14.864 13.864 16.375 12 16.375C10.136 16.375 8.625 14.864 8.625 13C8.625 11.136 10.136 9.625 12 9.625C13.864 9.625 15.375 11.136 15.375 13Z",
    fill: "#57B661"
  })), _circle17 || (_circle17 = /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 5.6875,
    r: 0.5625,
    fill: "#57B661"
  })), _circle18 || (_circle18 = /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 20.3125,
    r: 0.5625,
    fill: "#57B661"
  })), _circle19 || (_circle19 = /*#__PURE__*/React.createElement("circle", {
    cx: 19.3125,
    cy: 13,
    r: 0.5625,
    fill: "#57B661"
  })), _circle20 || (_circle20 = /*#__PURE__*/React.createElement("circle", {
    cx: 4.6875,
    cy: 13,
    r: 0.5625,
    fill: "#57B661"
  })), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter4_d_73_5274)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 9,
    fill: "white"
  }))), _circle21 || (_circle21 = /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 5.34375,
    fill: "white",
    stroke: "#57B661",
    strokeWidth: 0.5625
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.3061 8.8153L19.4393 6.93306C19.1308 6.48092 18.7821 6.05835 18.3984 5.6705L18.3296 5.60171C17.9416 5.21789 17.5189 4.8691 17.0666 4.56049L15.1844 6.69368C16.0534 7.2163 16.7834 7.94634 17.3061 8.8153ZM17.306 15.1847C16.7833 16.0537 16.0533 16.7837 15.1843 17.3063L17.0665 19.4395C17.5223 19.1286 17.948 18.7768 18.3383 18.3895L18.3896 18.3382C18.7768 17.948 19.1284 17.5225 19.4392 17.067L17.306 15.1847ZM8.81535 17.306C7.9464 16.7834 7.21636 16.0533 6.69375 15.1843L4.56061 17.0665C5.19609 17.9978 6.00188 18.8037 6.93316 19.4392L8.81535 17.306ZM6.69366 8.81568C7.21626 7.94669 7.94628 7.2166 8.81522 6.69392L6.93307 4.56082C6.0018 5.19636 5.19602 6.0022 4.56055 6.93352L6.69366 8.81568Z",
    fill: "#57B661"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M15.375 12C15.375 13.864 13.864 15.375 12 15.375C10.136 15.375 8.625 13.864 8.625 12C8.625 10.136 10.136 8.625 12 8.625C13.864 8.625 15.375 10.136 15.375 12Z",
    fill: "#57B661"
  })), _circle22 || (_circle22 = /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 4.6875,
    r: 0.5625,
    fill: "#57B661"
  })), _circle23 || (_circle23 = /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 19.3125,
    r: 0.5625,
    fill: "#57B661"
  })), _circle24 || (_circle24 = /*#__PURE__*/React.createElement("circle", {
    cx: 19.3125,
    cy: 12,
    r: 0.5625,
    fill: "#57B661"
  })), _circle25 || (_circle25 = /*#__PURE__*/React.createElement("circle", {
    cx: 4.6875,
    cy: 12,
    r: 0.5625,
    fill: "#57B661"
  })), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter5_d_73_5274)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 32,
    cy: 19,
    r: 9,
    fill: "white"
  }))), _circle26 || (_circle26 = /*#__PURE__*/React.createElement("circle", {
    cx: 32,
    cy: 19,
    r: 5.34375,
    fill: "white",
    stroke: "#C7AD7A",
    strokeWidth: 0.5625
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M37.3061 15.8153L39.4393 13.9331C39.1308 13.4809 38.7821 13.0584 38.3984 12.6705L38.3296 12.6017C37.9416 12.2179 37.5189 11.8691 37.0666 11.5605L35.1844 13.6937C36.0534 14.2163 36.7834 14.9463 37.3061 15.8153ZM37.306 22.1847C36.7833 23.0537 36.0533 23.7837 35.1843 24.3063L37.0665 26.4395C37.5223 26.1286 37.948 25.7768 38.3383 25.3895L38.3896 25.3382C38.7768 24.948 39.1284 24.5225 39.4392 24.067L37.306 22.1847ZM28.8153 24.306C27.9464 23.7834 27.2164 23.0533 26.6937 22.1843L24.5606 24.0665C25.1961 24.9978 26.0019 25.8037 26.9332 26.4392L28.8153 24.306ZM26.6937 15.8157C27.2163 14.9467 27.9463 14.2166 28.8152 13.6939L26.9331 11.5608C26.0018 12.1964 25.196 13.0022 24.5605 13.9335L26.6937 15.8157Z",
    fill: "#C7AD7A"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M35.375 19C35.375 20.864 33.864 22.375 32 22.375C30.136 22.375 28.625 20.864 28.625 19C28.625 17.136 30.136 15.625 32 15.625C33.864 15.625 35.375 17.136 35.375 19Z",
    fill: "#C7AD7A"
  })), _circle27 || (_circle27 = /*#__PURE__*/React.createElement("circle", {
    cx: 32,
    cy: 11.6875,
    r: 0.5625,
    fill: "#C7AD7A"
  })), _circle28 || (_circle28 = /*#__PURE__*/React.createElement("circle", {
    cx: 32,
    cy: 26.3125,
    r: 0.5625,
    fill: "#C7AD7A"
  })), _circle29 || (_circle29 = /*#__PURE__*/React.createElement("circle", {
    cx: 39.3125,
    cy: 19,
    r: 0.5625,
    fill: "#C7AD7A"
  })), _circle30 || (_circle30 = /*#__PURE__*/React.createElement("circle", {
    cx: 24.6875,
    cy: 19,
    r: 0.5625,
    fill: "#C7AD7A"
  })), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter6_d_73_5274)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 32,
    cy: 18,
    r: 9,
    fill: "white"
  }))), _circle31 || (_circle31 = /*#__PURE__*/React.createElement("circle", {
    cx: 32,
    cy: 18,
    r: 5.34375,
    fill: "white",
    stroke: "#C7AD7A",
    strokeWidth: 0.5625
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M37.3061 14.8153L39.4393 12.9331C39.1308 12.4809 38.7821 12.0584 38.3984 11.6705L38.3296 11.6017C37.9416 11.2179 37.5189 10.8691 37.0666 10.5605L35.1844 12.6937C36.0534 13.2163 36.7834 13.9463 37.3061 14.8153ZM37.306 21.1847C36.7833 22.0537 36.0533 22.7837 35.1843 23.3063L37.0665 25.4395C37.5223 25.1286 37.948 24.7768 38.3383 24.3895L38.3896 24.3382C38.7768 23.948 39.1284 23.5225 39.4392 23.067L37.306 21.1847ZM28.8153 23.306C27.9464 22.7834 27.2164 22.0533 26.6937 21.1843L24.5606 23.0665C25.1961 23.9978 26.0019 24.8037 26.9332 25.4392L28.8153 23.306ZM26.6937 14.8157C27.2163 13.9467 27.9463 13.2166 28.8152 12.6939L26.9331 10.5608C26.0018 11.1964 25.196 12.0022 24.5605 12.9335L26.6937 14.8157Z",
    fill: "#C7AD7A"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M35.375 18C35.375 19.864 33.864 21.375 32 21.375C30.136 21.375 28.625 19.864 28.625 18C28.625 16.136 30.136 14.625 32 14.625C33.864 14.625 35.375 16.136 35.375 18Z",
    fill: "#C7AD7A"
  })), _circle32 || (_circle32 = /*#__PURE__*/React.createElement("circle", {
    cx: 32,
    cy: 10.6875,
    r: 0.5625,
    fill: "#C7AD7A"
  })), _circle33 || (_circle33 = /*#__PURE__*/React.createElement("circle", {
    cx: 32,
    cy: 25.3125,
    r: 0.5625,
    fill: "#C7AD7A"
  })), _circle34 || (_circle34 = /*#__PURE__*/React.createElement("circle", {
    cx: 39.3125,
    cy: 18,
    r: 0.5625,
    fill: "#C7AD7A"
  })), _circle35 || (_circle35 = /*#__PURE__*/React.createElement("circle", {
    cx: 24.6875,
    cy: 18,
    r: 0.5625,
    fill: "#C7AD7A"
  })), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter7_d_73_5274)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 32,
    cy: 17,
    r: 9,
    fill: "white"
  }))), _circle36 || (_circle36 = /*#__PURE__*/React.createElement("circle", {
    cx: 32,
    cy: 17,
    r: 5.34375,
    fill: "white",
    stroke: "#C7AD7A",
    strokeWidth: 0.5625
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M37.3061 13.8153L39.4393 11.9331C39.1308 11.4809 38.7821 11.0584 38.3984 10.6705L38.3296 10.6017C37.9416 10.2179 37.5189 9.8691 37.0666 9.56049L35.1844 11.6937C36.0534 12.2163 36.7834 12.9463 37.3061 13.8153ZM37.306 20.1847C36.7833 21.0537 36.0533 21.7837 35.1843 22.3063L37.0665 24.4395C37.5223 24.1286 37.948 23.7768 38.3383 23.3895L38.3896 23.3382C38.7768 22.948 39.1284 22.5225 39.4392 22.067L37.306 20.1847ZM28.8153 22.306C27.9464 21.7834 27.2164 21.0533 26.6937 20.1843L24.5606 22.0665C25.1961 22.9978 26.0019 23.8037 26.9332 24.4392L28.8153 22.306ZM26.6937 13.8157C27.2163 12.9467 27.9463 12.2166 28.8152 11.6939L26.9331 9.56082C26.0018 10.1964 25.196 11.0022 24.5605 11.9335L26.6937 13.8157Z",
    fill: "#C7AD7A"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M35.375 17C35.375 18.864 33.864 20.375 32 20.375C30.136 20.375 28.625 18.864 28.625 17C28.625 15.136 30.136 13.625 32 13.625C33.864 13.625 35.375 15.136 35.375 17Z",
    fill: "#C7AD7A"
  })), _circle37 || (_circle37 = /*#__PURE__*/React.createElement("circle", {
    cx: 32,
    cy: 9.6875,
    r: 0.5625,
    fill: "#C7AD7A"
  })), _circle38 || (_circle38 = /*#__PURE__*/React.createElement("circle", {
    cx: 32,
    cy: 24.3125,
    r: 0.5625,
    fill: "#C7AD7A"
  })), _circle39 || (_circle39 = /*#__PURE__*/React.createElement("circle", {
    cx: 39.3125,
    cy: 17,
    r: 0.5625,
    fill: "#C7AD7A"
  })), _circle40 || (_circle40 = /*#__PURE__*/React.createElement("circle", {
    cx: 24.6875,
    cy: 17,
    r: 0.5625,
    fill: "#C7AD7A"
  })), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter8_d_73_5274)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 32,
    cy: 16,
    r: 9,
    fill: "white"
  }))), _circle41 || (_circle41 = /*#__PURE__*/React.createElement("circle", {
    cx: 32,
    cy: 16,
    r: 5.34375,
    fill: "white",
    stroke: "#C7AD7A",
    strokeWidth: 0.5625
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M37.3061 12.8153L39.4393 10.9331C39.1308 10.4809 38.7821 10.0584 38.3984 9.6705L38.3296 9.60171C37.9416 9.21789 37.5189 8.8691 37.0666 8.56049L35.1844 10.6937C36.0534 11.2163 36.7834 11.9463 37.3061 12.8153ZM37.306 19.1847C36.7833 20.0537 36.0533 20.7837 35.1843 21.3063L37.0665 23.4395C37.5223 23.1286 37.948 22.7768 38.3383 22.3895L38.3896 22.3382C38.7768 21.948 39.1284 21.5225 39.4392 21.067L37.306 19.1847ZM28.8153 21.306C27.9464 20.7834 27.2164 20.0533 26.6937 19.1843L24.5606 21.0665C25.1961 21.9978 26.0019 22.8037 26.9332 23.4392L28.8153 21.306ZM26.6937 12.8157C27.2163 11.9467 27.9463 11.2166 28.8152 10.6939L26.9331 8.56082C26.0018 9.19636 25.196 10.0022 24.5605 10.9335L26.6937 12.8157Z",
    fill: "#C7AD7A"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M35.375 16C35.375 17.864 33.864 19.375 32 19.375C30.136 19.375 28.625 17.864 28.625 16C28.625 14.136 30.136 12.625 32 12.625C33.864 12.625 35.375 14.136 35.375 16Z",
    fill: "#C7AD7A"
  })), _circle42 || (_circle42 = /*#__PURE__*/React.createElement("circle", {
    cx: 32,
    cy: 8.6875,
    r: 0.5625,
    fill: "#C7AD7A"
  })), _circle43 || (_circle43 = /*#__PURE__*/React.createElement("circle", {
    cx: 32,
    cy: 23.3125,
    r: 0.5625,
    fill: "#C7AD7A"
  })), _circle44 || (_circle44 = /*#__PURE__*/React.createElement("circle", {
    cx: 39.3125,
    cy: 16,
    r: 0.5625,
    fill: "#C7AD7A"
  })), _circle45 || (_circle45 = /*#__PURE__*/React.createElement("circle", {
    cx: 24.6875,
    cy: 16,
    r: 0.5625,
    fill: "#C7AD7A"
  })), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter9_d_73_5274)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 32,
    cy: 15,
    r: 9,
    fill: "white"
  }))), _circle46 || (_circle46 = /*#__PURE__*/React.createElement("circle", {
    cx: 32,
    cy: 15,
    r: 5.34375,
    fill: "white",
    stroke: "#C7AD7A",
    strokeWidth: 0.5625
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M37.3061 11.8153L39.4393 9.93306C39.1308 9.48092 38.7821 9.05835 38.3984 8.6705L38.3296 8.60171C37.9416 8.21789 37.5189 7.8691 37.0666 7.56049L35.1844 9.69368C36.0534 10.2163 36.7834 10.9463 37.3061 11.8153ZM37.306 18.1847C36.7833 19.0537 36.0533 19.7837 35.1843 20.3063L37.0665 22.4395C37.5223 22.1286 37.948 21.7768 38.3383 21.3895L38.3896 21.3382C38.7768 20.948 39.1284 20.5225 39.4392 20.067L37.306 18.1847ZM28.8153 20.306C27.9464 19.7834 27.2164 19.0533 26.6937 18.1843L24.5606 20.0665C25.1961 20.9978 26.0019 21.8037 26.9332 22.4392L28.8153 20.306ZM26.6937 11.8157C27.2163 10.9467 27.9463 10.2166 28.8152 9.69392L26.9331 7.56082C26.0018 8.19636 25.196 9.0022 24.5605 9.93352L26.6937 11.8157Z",
    fill: "#C7AD7A"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M35.375 15C35.375 16.864 33.864 18.375 32 18.375C30.136 18.375 28.625 16.864 28.625 15C28.625 13.136 30.136 11.625 32 11.625C33.864 11.625 35.375 13.136 35.375 15Z",
    fill: "#C7AD7A"
  })), _circle47 || (_circle47 = /*#__PURE__*/React.createElement("circle", {
    cx: 32,
    cy: 7.6875,
    r: 0.5625,
    fill: "#C7AD7A"
  })), _circle48 || (_circle48 = /*#__PURE__*/React.createElement("circle", {
    cx: 32,
    cy: 22.3125,
    r: 0.5625,
    fill: "#C7AD7A"
  })), _circle49 || (_circle49 = /*#__PURE__*/React.createElement("circle", {
    cx: 39.3125,
    cy: 15,
    r: 0.5625,
    fill: "#C7AD7A"
  })), _circle50 || (_circle50 = /*#__PURE__*/React.createElement("circle", {
    cx: 24.6875,
    cy: 15,
    r: 0.5625,
    fill: "#C7AD7A"
  })), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter10_d_73_5274)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 32,
    cy: 14,
    r: 9,
    fill: "white"
  }))), _circle51 || (_circle51 = /*#__PURE__*/React.createElement("circle", {
    cx: 32,
    cy: 14,
    r: 5.34375,
    fill: "white",
    stroke: "#C7AD7A",
    strokeWidth: 0.5625
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M37.3061 10.8153L39.4393 8.93306C39.1308 8.48092 38.7821 8.05835 38.3984 7.6705L38.3296 7.60171C37.9416 7.21789 37.5189 6.8691 37.0666 6.56049L35.1844 8.69368C36.0534 9.2163 36.7834 9.94634 37.3061 10.8153ZM37.306 17.1847C36.7833 18.0537 36.0533 18.7837 35.1843 19.3063L37.0665 21.4395C37.5223 21.1286 37.948 20.7768 38.3383 20.3895L38.3896 20.3382C38.7768 19.948 39.1284 19.5225 39.4392 19.067L37.306 17.1847ZM28.8153 19.306C27.9464 18.7834 27.2164 18.0533 26.6937 17.1843L24.5606 19.0665C25.1961 19.9978 26.0019 20.8037 26.9332 21.4392L28.8153 19.306ZM26.6937 10.8157C27.2163 9.94669 27.9463 9.2166 28.8152 8.69392L26.9331 6.56082C26.0018 7.19636 25.196 8.0022 24.5605 8.93352L26.6937 10.8157Z",
    fill: "#C7AD7A"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M35.375 14C35.375 15.864 33.864 17.375 32 17.375C30.136 17.375 28.625 15.864 28.625 14C28.625 12.136 30.136 10.625 32 10.625C33.864 10.625 35.375 12.136 35.375 14Z",
    fill: "#C7AD7A"
  })), _circle52 || (_circle52 = /*#__PURE__*/React.createElement("circle", {
    cx: 32,
    cy: 6.6875,
    r: 0.5625,
    fill: "#C7AD7A"
  })), _circle53 || (_circle53 = /*#__PURE__*/React.createElement("circle", {
    cx: 32,
    cy: 21.3125,
    r: 0.5625,
    fill: "#C7AD7A"
  })), _circle54 || (_circle54 = /*#__PURE__*/React.createElement("circle", {
    cx: 39.3125,
    cy: 14,
    r: 0.5625,
    fill: "#C7AD7A"
  })), _circle55 || (_circle55 = /*#__PURE__*/React.createElement("circle", {
    cx: 24.6875,
    cy: 14,
    r: 0.5625,
    fill: "#C7AD7A"
  })), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter11_d_73_5274)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 32,
    cy: 13,
    r: 9,
    fill: "white"
  }))), _circle56 || (_circle56 = /*#__PURE__*/React.createElement("circle", {
    cx: 32,
    cy: 13,
    r: 5.34375,
    fill: "white",
    stroke: "#C7AD7A",
    strokeWidth: 0.5625
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M37.3061 9.8153L39.4393 7.93306C39.1308 7.48092 38.7821 7.05835 38.3984 6.6705L38.3296 6.60171C37.9416 6.21789 37.5189 5.8691 37.0666 5.56049L35.1844 7.69368C36.0534 8.2163 36.7834 8.94634 37.3061 9.8153ZM37.306 16.1847C36.7833 17.0537 36.0533 17.7837 35.1843 18.3063L37.0665 20.4395C37.5223 20.1286 37.948 19.7768 38.3383 19.3895L38.3896 19.3382C38.7768 18.948 39.1284 18.5225 39.4392 18.067L37.306 16.1847ZM28.8153 18.306C27.9464 17.7834 27.2164 17.0533 26.6937 16.1843L24.5606 18.0665C25.1961 18.9978 26.0019 19.8037 26.9332 20.4392L28.8153 18.306ZM26.6937 9.81568C27.2163 8.94669 27.9463 8.2166 28.8152 7.69392L26.9331 5.56082C26.0018 6.19636 25.196 7.0022 24.5605 7.93352L26.6937 9.81568Z",
    fill: "#C7AD7A"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M35.375 13C35.375 14.864 33.864 16.375 32 16.375C30.136 16.375 28.625 14.864 28.625 13C28.625 11.136 30.136 9.625 32 9.625C33.864 9.625 35.375 11.136 35.375 13Z",
    fill: "#C7AD7A"
  })), _circle57 || (_circle57 = /*#__PURE__*/React.createElement("circle", {
    cx: 32,
    cy: 5.6875,
    r: 0.5625,
    fill: "#C7AD7A"
  })), _circle58 || (_circle58 = /*#__PURE__*/React.createElement("circle", {
    cx: 32,
    cy: 20.3125,
    r: 0.5625,
    fill: "#C7AD7A"
  })), _circle59 || (_circle59 = /*#__PURE__*/React.createElement("circle", {
    cx: 39.3125,
    cy: 13,
    r: 0.5625,
    fill: "#C7AD7A"
  })), _circle60 || (_circle60 = /*#__PURE__*/React.createElement("circle", {
    cx: 24.6875,
    cy: 13,
    r: 0.5625,
    fill: "#C7AD7A"
  })), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter12_d_73_5274)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 32,
    cy: 12,
    r: 9,
    fill: "white"
  }))), _circle61 || (_circle61 = /*#__PURE__*/React.createElement("circle", {
    cx: 32,
    cy: 12,
    r: 5.34375,
    fill: "white",
    stroke: "#C7AD7A",
    strokeWidth: 0.5625
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M37.3061 8.8153L39.4393 6.93306C39.1308 6.48092 38.7821 6.05835 38.3984 5.6705L38.3296 5.60171C37.9416 5.21789 37.5189 4.8691 37.0666 4.56049L35.1844 6.69368C36.0534 7.2163 36.7834 7.94634 37.3061 8.8153ZM37.306 15.1847C36.7833 16.0537 36.0533 16.7837 35.1843 17.3063L37.0665 19.4395C37.5223 19.1286 37.948 18.7768 38.3383 18.3895L38.3896 18.3382C38.7768 17.948 39.1284 17.5225 39.4392 17.067L37.306 15.1847ZM28.8153 17.306C27.9464 16.7834 27.2164 16.0533 26.6937 15.1843L24.5606 17.0665C25.1961 17.9978 26.0019 18.8037 26.9332 19.4392L28.8153 17.306ZM26.6937 8.81568C27.2163 7.94669 27.9463 7.2166 28.8152 6.69392L26.9331 4.56082C26.0018 5.19636 25.196 6.0022 24.5605 6.93352L26.6937 8.81568Z",
    fill: "#C7AD7A"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M35.375 12C35.375 13.864 33.864 15.375 32 15.375C30.136 15.375 28.625 13.864 28.625 12C28.625 10.136 30.136 8.625 32 8.625C33.864 8.625 35.375 10.136 35.375 12Z",
    fill: "#C7AD7A"
  })), _circle62 || (_circle62 = /*#__PURE__*/React.createElement("circle", {
    cx: 32,
    cy: 4.6875,
    r: 0.5625,
    fill: "#C7AD7A"
  })), _circle63 || (_circle63 = /*#__PURE__*/React.createElement("circle", {
    cx: 32,
    cy: 19.3125,
    r: 0.5625,
    fill: "#C7AD7A"
  })), _circle64 || (_circle64 = /*#__PURE__*/React.createElement("circle", {
    cx: 39.3125,
    cy: 12,
    r: 0.5625,
    fill: "#C7AD7A"
  })), _circle65 || (_circle65 = /*#__PURE__*/React.createElement("circle", {
    cx: 24.6875,
    cy: 12,
    r: 0.5625,
    fill: "#C7AD7A"
  })), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter13_d_73_5274)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 32,
    cy: 11,
    r: 9,
    fill: "white"
  }))), _circle66 || (_circle66 = /*#__PURE__*/React.createElement("circle", {
    cx: 32,
    cy: 11,
    r: 5.34375,
    fill: "white",
    stroke: "#C7AD7A",
    strokeWidth: 0.5625
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M37.3061 7.8153L39.4393 5.93306C39.1308 5.48092 38.7821 5.05835 38.3984 4.6705L38.3296 4.60171C37.9416 4.21789 37.5189 3.8691 37.0666 3.56049L35.1844 5.69368C36.0534 6.2163 36.7834 6.94634 37.3061 7.8153ZM37.306 14.1847C36.7833 15.0537 36.0533 15.7837 35.1843 16.3063L37.0665 18.4395C37.5223 18.1286 37.948 17.7768 38.3383 17.3895L38.3896 17.3382C38.7768 16.948 39.1284 16.5225 39.4392 16.067L37.306 14.1847ZM28.8153 16.306C27.9464 15.7834 27.2164 15.0533 26.6937 14.1843L24.5606 16.0665C25.1961 16.9978 26.0019 17.8037 26.9332 18.4392L28.8153 16.306ZM26.6937 7.81568C27.2163 6.94669 27.9463 6.2166 28.8152 5.69392L26.9331 3.56082C26.0018 4.19636 25.196 5.0022 24.5605 5.93352L26.6937 7.81568Z",
    fill: "#C7AD7A"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M35.375 11C35.375 12.864 33.864 14.375 32 14.375C30.136 14.375 28.625 12.864 28.625 11C28.625 9.13604 30.136 7.625 32 7.625C33.864 7.625 35.375 9.13604 35.375 11Z",
    fill: "#C7AD7A"
  })), _circle67 || (_circle67 = /*#__PURE__*/React.createElement("circle", {
    cx: 32,
    cy: 3.6875,
    r: 0.5625,
    fill: "#C7AD7A"
  })), _circle68 || (_circle68 = /*#__PURE__*/React.createElement("circle", {
    cx: 32,
    cy: 18.3125,
    r: 0.5625,
    fill: "#C7AD7A"
  })), _circle69 || (_circle69 = /*#__PURE__*/React.createElement("circle", {
    cx: 39.3125,
    cy: 11,
    r: 0.5625,
    fill: "#C7AD7A"
  })), _circle70 || (_circle70 = /*#__PURE__*/React.createElement("circle", {
    cx: 24.6875,
    cy: 11,
    r: 0.5625,
    fill: "#C7AD7A"
  })), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter14_d_73_5274)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 21,
    cy: 25,
    r: 9,
    fill: "white"
  }))), _circle71 || (_circle71 = /*#__PURE__*/React.createElement("circle", {
    cx: 21,
    cy: 25,
    r: 5.34375,
    fill: "white",
    stroke: "#D93355",
    strokeWidth: 0.5625
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M26.3061 21.8153L28.4393 19.9331C28.1308 19.4809 27.7821 19.0584 27.3984 18.6705L27.3296 18.6017C26.9416 18.2179 26.5189 17.8691 26.0666 17.5605L24.1844 19.6937C25.0534 20.2163 25.7834 20.9463 26.3061 21.8153ZM26.306 28.1847C25.7833 29.0537 25.0533 29.7837 24.1843 30.3063L26.0665 32.4395C26.5223 32.1286 26.948 31.7768 27.3383 31.3895L27.3896 31.3382C27.7768 30.948 28.1284 30.5225 28.4392 30.067L26.306 28.1847ZM17.8153 30.306C16.9464 29.7834 16.2164 29.0533 15.6937 28.1843L13.5606 30.0665C14.1961 30.9978 15.0019 31.8037 15.9332 32.4392L17.8153 30.306ZM15.6937 21.8157C16.2163 20.9467 16.9463 20.2166 17.8152 19.6939L15.9331 17.5608C15.0018 18.1964 14.196 19.0022 13.5605 19.9335L15.6937 21.8157Z",
    fill: "#D93355"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M24.375 25C24.375 26.864 22.864 28.375 21 28.375C19.136 28.375 17.625 26.864 17.625 25C17.625 23.136 19.136 21.625 21 21.625C22.864 21.625 24.375 23.136 24.375 25Z",
    fill: "#D93355"
  })), _circle72 || (_circle72 = /*#__PURE__*/React.createElement("circle", {
    cx: 21,
    cy: 17.6875,
    r: 0.5625,
    fill: "#D93355"
  })), _circle73 || (_circle73 = /*#__PURE__*/React.createElement("circle", {
    cx: 21,
    cy: 32.3125,
    r: 0.5625,
    fill: "#D93355"
  })), _circle74 || (_circle74 = /*#__PURE__*/React.createElement("circle", {
    cx: 28.3125,
    cy: 25,
    r: 0.5625,
    fill: "#D93355"
  })), _circle75 || (_circle75 = /*#__PURE__*/React.createElement("circle", {
    cx: 13.6875,
    cy: 25,
    r: 0.5625,
    fill: "#D93355"
  })), _g16 || (_g16 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter15_d_73_5274)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 21,
    cy: 24,
    r: 9,
    fill: "white"
  }))), _circle76 || (_circle76 = /*#__PURE__*/React.createElement("circle", {
    cx: 21,
    cy: 24,
    r: 5.34375,
    fill: "white",
    stroke: "#D93355",
    strokeWidth: 0.5625
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M26.3061 20.8153L28.4393 18.9331C28.1308 18.4809 27.7821 18.0584 27.3984 17.6705L27.3296 17.6017C26.9416 17.2179 26.5189 16.8691 26.0666 16.5605L24.1844 18.6937C25.0534 19.2163 25.7834 19.9463 26.3061 20.8153ZM26.306 27.1847C25.7833 28.0537 25.0533 28.7837 24.1843 29.3063L26.0665 31.4395C26.5223 31.1286 26.948 30.7768 27.3383 30.3895L27.3896 30.3382C27.7768 29.948 28.1284 29.5225 28.4392 29.067L26.306 27.1847ZM17.8153 29.306C16.9464 28.7834 16.2164 28.0533 15.6937 27.1843L13.5606 29.0665C14.1961 29.9978 15.0019 30.8037 15.9332 31.4392L17.8153 29.306ZM15.6937 20.8157C16.2163 19.9467 16.9463 19.2166 17.8152 18.6939L15.9331 16.5608C15.0018 17.1964 14.196 18.0022 13.5605 18.9335L15.6937 20.8157Z",
    fill: "#D93355"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M24.375 24C24.375 25.864 22.864 27.375 21 27.375C19.136 27.375 17.625 25.864 17.625 24C17.625 22.136 19.136 20.625 21 20.625C22.864 20.625 24.375 22.136 24.375 24Z",
    fill: "#D93355"
  })), _circle77 || (_circle77 = /*#__PURE__*/React.createElement("circle", {
    cx: 21,
    cy: 16.6875,
    r: 0.5625,
    fill: "#D93355"
  })), _circle78 || (_circle78 = /*#__PURE__*/React.createElement("circle", {
    cx: 21,
    cy: 31.3125,
    r: 0.5625,
    fill: "#D93355"
  })), _circle79 || (_circle79 = /*#__PURE__*/React.createElement("circle", {
    cx: 28.3125,
    cy: 24,
    r: 0.5625,
    fill: "#D93355"
  })), _circle80 || (_circle80 = /*#__PURE__*/React.createElement("circle", {
    cx: 13.6875,
    cy: 24,
    r: 0.5625,
    fill: "#D93355"
  })), _g17 || (_g17 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter16_d_73_5274)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 21,
    cy: 23,
    r: 9,
    fill: "white"
  }))), _circle81 || (_circle81 = /*#__PURE__*/React.createElement("circle", {
    cx: 21,
    cy: 23,
    r: 5.34375,
    fill: "white",
    stroke: "#D93355",
    strokeWidth: 0.5625
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M26.3061 19.8153L28.4393 17.9331C28.1308 17.4809 27.7821 17.0584 27.3984 16.6705L27.3296 16.6017C26.9416 16.2179 26.5189 15.8691 26.0666 15.5605L24.1844 17.6937C25.0534 18.2163 25.7834 18.9463 26.3061 19.8153ZM26.306 26.1847C25.7833 27.0537 25.0533 27.7837 24.1843 28.3063L26.0665 30.4395C26.5223 30.1286 26.948 29.7768 27.3383 29.3895L27.3896 29.3382C27.7768 28.948 28.1284 28.5225 28.4392 28.067L26.306 26.1847ZM17.8153 28.306C16.9464 27.7834 16.2164 27.0533 15.6937 26.1843L13.5606 28.0665C14.1961 28.9978 15.0019 29.8037 15.9332 30.4392L17.8153 28.306ZM15.6937 19.8157C16.2163 18.9467 16.9463 18.2166 17.8152 17.6939L15.9331 15.5608C15.0018 16.1964 14.196 17.0022 13.5605 17.9335L15.6937 19.8157Z",
    fill: "#D93355"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M24.375 23C24.375 24.864 22.864 26.375 21 26.375C19.136 26.375 17.625 24.864 17.625 23C17.625 21.136 19.136 19.625 21 19.625C22.864 19.625 24.375 21.136 24.375 23Z",
    fill: "#D93355"
  })), _circle82 || (_circle82 = /*#__PURE__*/React.createElement("circle", {
    cx: 21,
    cy: 15.6875,
    r: 0.5625,
    fill: "#D93355"
  })), _circle83 || (_circle83 = /*#__PURE__*/React.createElement("circle", {
    cx: 21,
    cy: 30.3125,
    r: 0.5625,
    fill: "#D93355"
  })), _circle84 || (_circle84 = /*#__PURE__*/React.createElement("circle", {
    cx: 28.3125,
    cy: 23,
    r: 0.5625,
    fill: "#D93355"
  })), _circle85 || (_circle85 = /*#__PURE__*/React.createElement("circle", {
    cx: 13.6875,
    cy: 23,
    r: 0.5625,
    fill: "#D93355"
  })), _g18 || (_g18 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter17_d_73_5274)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 21,
    cy: 22,
    r: 9,
    fill: "white"
  }))), _circle86 || (_circle86 = /*#__PURE__*/React.createElement("circle", {
    cx: 21,
    cy: 22,
    r: 5.34375,
    fill: "white",
    stroke: "#D93355",
    strokeWidth: 0.5625
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M26.3061 18.8153L28.4393 16.9331C28.1308 16.4809 27.7821 16.0584 27.3984 15.6705L27.3296 15.6017C26.9416 15.2179 26.5189 14.8691 26.0666 14.5605L24.1844 16.6937C25.0534 17.2163 25.7834 17.9463 26.3061 18.8153ZM26.306 25.1847C25.7833 26.0537 25.0533 26.7837 24.1843 27.3063L26.0665 29.4395C26.5223 29.1286 26.948 28.7768 27.3383 28.3895L27.3896 28.3382C27.7768 27.948 28.1284 27.5225 28.4392 27.067L26.306 25.1847ZM17.8153 27.306C16.9464 26.7834 16.2164 26.0533 15.6937 25.1843L13.5606 27.0665C14.1961 27.9978 15.0019 28.8037 15.9332 29.4392L17.8153 27.306ZM15.6937 18.8157C16.2163 17.9467 16.9463 17.2166 17.8152 16.6939L15.9331 14.5608C15.0018 15.1964 14.196 16.0022 13.5605 16.9335L15.6937 18.8157Z",
    fill: "#D93355"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M24.375 22C24.375 23.864 22.864 25.375 21 25.375C19.136 25.375 17.625 23.864 17.625 22C17.625 20.136 19.136 18.625 21 18.625C22.864 18.625 24.375 20.136 24.375 22Z",
    fill: "#D93355"
  })), _circle87 || (_circle87 = /*#__PURE__*/React.createElement("circle", {
    cx: 21,
    cy: 14.6875,
    r: 0.5625,
    fill: "#D93355"
  })), _circle88 || (_circle88 = /*#__PURE__*/React.createElement("circle", {
    cx: 21,
    cy: 29.3125,
    r: 0.5625,
    fill: "#D93355"
  })), _circle89 || (_circle89 = /*#__PURE__*/React.createElement("circle", {
    cx: 28.3125,
    cy: 22,
    r: 0.5625,
    fill: "#D93355"
  })), _circle90 || (_circle90 = /*#__PURE__*/React.createElement("circle", {
    cx: 13.6875,
    cy: 22,
    r: 0.5625,
    fill: "#D93355"
  })), _g19 || (_g19 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter18_d_73_5274)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 21,
    cy: 21,
    r: 9,
    fill: "white"
  }))), _circle91 || (_circle91 = /*#__PURE__*/React.createElement("circle", {
    cx: 21,
    cy: 21,
    r: 5.34375,
    fill: "white",
    stroke: "#D93355",
    strokeWidth: 0.5625
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M26.3061 17.8153L28.4393 15.9331C28.1308 15.4809 27.7821 15.0584 27.3984 14.6705L27.3296 14.6017C26.9416 14.2179 26.5189 13.8691 26.0666 13.5605L24.1844 15.6937C25.0534 16.2163 25.7834 16.9463 26.3061 17.8153ZM26.306 24.1847C25.7833 25.0537 25.0533 25.7837 24.1843 26.3063L26.0665 28.4395C26.5223 28.1286 26.948 27.7768 27.3383 27.3895L27.3896 27.3382C27.7768 26.948 28.1284 26.5225 28.4392 26.067L26.306 24.1847ZM17.8153 26.306C16.9464 25.7834 16.2164 25.0533 15.6937 24.1843L13.5606 26.0665C14.1961 26.9978 15.0019 27.8037 15.9332 28.4392L17.8153 26.306ZM15.6937 17.8157C16.2163 16.9467 16.9463 16.2166 17.8152 15.6939L15.9331 13.5608C15.0018 14.1964 14.196 15.0022 13.5605 15.9335L15.6937 17.8157Z",
    fill: "#D93355"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M24.375 21C24.375 22.864 22.864 24.375 21 24.375C19.136 24.375 17.625 22.864 17.625 21C17.625 19.136 19.136 17.625 21 17.625C22.864 17.625 24.375 19.136 24.375 21Z",
    fill: "#D93355"
  })), _circle92 || (_circle92 = /*#__PURE__*/React.createElement("circle", {
    cx: 21,
    cy: 13.6875,
    r: 0.5625,
    fill: "#D93355"
  })), _circle93 || (_circle93 = /*#__PURE__*/React.createElement("circle", {
    cx: 21,
    cy: 28.3125,
    r: 0.5625,
    fill: "#D93355"
  })), _circle94 || (_circle94 = /*#__PURE__*/React.createElement("circle", {
    cx: 28.3125,
    cy: 21,
    r: 0.5625,
    fill: "#D93355"
  })), _circle95 || (_circle95 = /*#__PURE__*/React.createElement("circle", {
    cx: 13.6875,
    cy: 21,
    r: 0.5625,
    fill: "#D93355"
  })), _g20 || (_g20 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter19_d_73_5274)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 21,
    cy: 20,
    r: 9,
    fill: "white"
  }))), _circle96 || (_circle96 = /*#__PURE__*/React.createElement("circle", {
    cx: 21,
    cy: 20,
    r: 5.34375,
    fill: "white",
    stroke: "#D93355",
    strokeWidth: 0.5625
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M26.3061 16.8153L28.4393 14.9331C28.1308 14.4809 27.7821 14.0584 27.3984 13.6705L27.3296 13.6017C26.9416 13.2179 26.5189 12.8691 26.0666 12.5605L24.1844 14.6937C25.0534 15.2163 25.7834 15.9463 26.3061 16.8153ZM26.306 23.1847C25.7833 24.0537 25.0533 24.7837 24.1843 25.3063L26.0665 27.4395C26.5223 27.1286 26.948 26.7768 27.3383 26.3895L27.3896 26.3382C27.7768 25.948 28.1284 25.5225 28.4392 25.067L26.306 23.1847ZM17.8153 25.306C16.9464 24.7834 16.2164 24.0533 15.6937 23.1843L13.5606 25.0665C14.1961 25.9978 15.0019 26.8037 15.9332 27.4392L17.8153 25.306ZM15.6937 16.8157C16.2163 15.9467 16.9463 15.2166 17.8152 14.6939L15.9331 12.5608C15.0018 13.1964 14.196 14.0022 13.5605 14.9335L15.6937 16.8157Z",
    fill: "#D93355"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M24.375 20C24.375 21.864 22.864 23.375 21 23.375C19.136 23.375 17.625 21.864 17.625 20C17.625 18.136 19.136 16.625 21 16.625C22.864 16.625 24.375 18.136 24.375 20Z",
    fill: "#D93355"
  })), _circle97 || (_circle97 = /*#__PURE__*/React.createElement("circle", {
    cx: 21,
    cy: 12.6875,
    r: 0.5625,
    fill: "#D93355"
  })), _circle98 || (_circle98 = /*#__PURE__*/React.createElement("circle", {
    cx: 21,
    cy: 27.3125,
    r: 0.5625,
    fill: "#D93355"
  })), _circle99 || (_circle99 = /*#__PURE__*/React.createElement("circle", {
    cx: 28.3125,
    cy: 20,
    r: 0.5625,
    fill: "#D93355"
  })), _circle100 || (_circle100 = /*#__PURE__*/React.createElement("circle", {
    cx: 13.6875,
    cy: 20,
    r: 0.5625,
    fill: "#D93355"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_73_5274",
    x: 0.75,
    y: 5.875,
    width: 22.5,
    height: 22.5,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1.125
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.125
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.3 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_73_5274"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_73_5274",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_d_73_5274",
    x: 0.75,
    y: 4.875,
    width: 22.5,
    height: 22.5,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1.125
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.125
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.3 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_73_5274"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_73_5274",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_d_73_5274",
    x: 0.75,
    y: 3.875,
    width: 22.5,
    height: 22.5,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1.125
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.125
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.3 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_73_5274"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_73_5274",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter3_d_73_5274",
    x: 0.75,
    y: 2.875,
    width: 22.5,
    height: 22.5,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1.125
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.125
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.3 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_73_5274"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_73_5274",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter4_d_73_5274",
    x: 0.75,
    y: 1.875,
    width: 22.5,
    height: 22.5,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1.125
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.125
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.3 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_73_5274"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_73_5274",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter5_d_73_5274",
    x: 20.75,
    y: 8.875,
    width: 22.5,
    height: 22.5,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1.125
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.125
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.3 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_73_5274"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_73_5274",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter6_d_73_5274",
    x: 20.75,
    y: 7.875,
    width: 22.5,
    height: 22.5,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1.125
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.125
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.3 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_73_5274"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_73_5274",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter7_d_73_5274",
    x: 20.75,
    y: 6.875,
    width: 22.5,
    height: 22.5,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1.125
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.125
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.3 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_73_5274"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_73_5274",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter8_d_73_5274",
    x: 20.75,
    y: 5.875,
    width: 22.5,
    height: 22.5,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1.125
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.125
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.3 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_73_5274"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_73_5274",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter9_d_73_5274",
    x: 20.75,
    y: 4.875,
    width: 22.5,
    height: 22.5,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1.125
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.125
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.3 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_73_5274"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_73_5274",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter10_d_73_5274",
    x: 20.75,
    y: 3.875,
    width: 22.5,
    height: 22.5,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1.125
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.125
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.3 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_73_5274"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_73_5274",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter11_d_73_5274",
    x: 20.75,
    y: 2.875,
    width: 22.5,
    height: 22.5,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1.125
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.125
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.3 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_73_5274"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_73_5274",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter12_d_73_5274",
    x: 20.75,
    y: 1.875,
    width: 22.5,
    height: 22.5,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1.125
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.125
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.3 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_73_5274"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_73_5274",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter13_d_73_5274",
    x: 20.75,
    y: 0.875,
    width: 22.5,
    height: 22.5,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1.125
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.125
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.3 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_73_5274"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_73_5274",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter14_d_73_5274",
    x: 9.75,
    y: 14.875,
    width: 22.5,
    height: 22.5,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1.125
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.125
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.3 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_73_5274"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_73_5274",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter15_d_73_5274",
    x: 9.75,
    y: 13.875,
    width: 22.5,
    height: 22.5,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1.125
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.125
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.3 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_73_5274"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_73_5274",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter16_d_73_5274",
    x: 9.75,
    y: 12.875,
    width: 22.5,
    height: 22.5,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1.125
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.125
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.3 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_73_5274"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_73_5274",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter17_d_73_5274",
    x: 9.75,
    y: 11.875,
    width: 22.5,
    height: 22.5,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1.125
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.125
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.3 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_73_5274"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_73_5274",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter18_d_73_5274",
    x: 9.75,
    y: 10.875,
    width: 22.5,
    height: 22.5,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1.125
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.125
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.3 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_73_5274"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_73_5274",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter19_d_73_5274",
    x: 9.75,
    y: 9.875,
    width: 22.5,
    height: 22.5,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1.125
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.125
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.3 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_73_5274"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_73_5274",
    result: "shape"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgChipsColIcon);
export default __webpack_public_path__ + "static/media/chipsColIcon.ea45c440130920f7152b5f795f338960.svg";
export { ForwardRef as ReactComponent };